import { Color } from '../../../enums/color'
import { Variant } from '../types/variant'

export const variantToBarColor: Record<Variant, Color> = {
  default: Color.Black,
  success: Color.Green400,
  error: Color.Red700,
}
